import moment from "moment";
import { Enums } from "../thor.enums";
import { thor } from "../typings/thor";

export const isSaleCreated = (sale: thor.SaleGet) => sale.status === Enums.SaleStatus.Created;

export const isSaleInLessThan48hours = (saleStartAt: string): boolean =>
    moment(saleStartAt).diff(moment(), "hours") < 48;

export const isSaleWithoutShipping = (sale: thor.SaleGet): boolean =>
    !(sale.shipping?.shipping_methods?.length || sale.shipping?.shipping_partners?.length);
